"use strict";
var mainImg = document.querySelector("#largeImg");
var imgs = document.querySelector(".gallery__list");
imgs.addEventListener("click", function(ev) {
    ev.preventDefault();
    var img = ev.target.closest(".list-item");
    if (!img || !img.querySelector("a")) return;
    var link = img.querySelector("a");
    mainImg.src = link.href;
});

//# sourceMappingURL=index.b915e41a.js.map
